import { noop } from 'lodash'
import { PaymentProvider } from '@/components/ds-checkout-modal/payment-context'
import { DialogEventHandler } from '@/types'

import { SponsoredListingDialog } from '../modals/sponsor-wizard'
import NoBillingUserDialog from '../modals/no-billing-user-modal'
import NextStepsModal from '../modals/next-steps-modal'

type DialogKeys = 'billingUser' | 'sponsoredListing' | 'nextSteps'

type Props = {
  listingId: string
  visible: Record<DialogKeys, boolean>
  showModal: (id: DialogKeys) => DialogEventHandler
  closeModal: (id: DialogKeys) => DialogEventHandler
  handleClose?: () => void
}

const SponsorDialogs = ({
  listingId,
  visible,
  showModal,
  closeModal,
  handleClose = noop
}: Props) => {
  const handleOnCloseSponsoredListing = () => {
    handleClose()
    closeModal('sponsoredListing')()
  }

  const handleOnCloseNextSteps = () => {
    handleClose()
    closeModal('nextSteps')()
  }

  return (
    <PaymentProvider>
      <NoBillingUserDialog open={visible.billingUser} onClose={closeModal('billingUser')} />
      <SponsoredListingDialog
        open={visible.sponsoredListing}
        listingId={listingId}
        onClose={handleOnCloseSponsoredListing}
        onSuccess={showModal('nextSteps')}
      />
      <NextStepsModal
        listingId={listingId}
        open={visible.nextSteps}
        onClose={handleOnCloseNextSteps}
      />
    </PaymentProvider>
  )
}

export default SponsorDialogs
